import React from 'react';

//images
import Logo from '../assets/logo.svg';

//link
import { Link } from 'react-scroll';

const Header = () => {
  return (
    <header className='py-8'>
      <div className='container mx-auto'>
        <div className='flex justify-between items-center'>
          {/* logo */}
          <a href='/'>
            <img src={Logo} alt="Logo" className='w-[45px] lg:w-[70px]' />
          </a>

          {/* button */}
          <Link className='btn btn-sm cursor-pointer flex items-center justify-center' to='contact' smooth={true} spy={true}>
            Work with me
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
